import { ImporterDocumentRow } from "./types";
import { ImporterTableAccountRow } from "./ImporterTableAccountRow";
import { ImporterTableUploadRow } from "./ImporterTableUploadRow";

interface Props {
    documentRow: ImporterDocumentRow;
    rowNumber: number;
}

export const ImporterTableRow: React.FC<Props> = ({
    documentRow,
    rowNumber,
}) => {
    if (documentRow.financialDocument) {
        return (
            <ImporterTableAccountRow
                documentRow={documentRow}
                rowNumber={rowNumber}
                financialDocument={documentRow.financialDocument}
                integrationAccount={documentRow.integrationAccount}
            />
        );
    }

    if (documentRow.file) {
        return (
            <ImporterTableUploadRow
                documentRow={documentRow}
                rowNumber={rowNumber}
                file={documentRow.file}
            />
        );
    }
};
